export const adminOrg = (params: { orgId: number }) => `organization:${params.orgId}`;
